module.exports = "/images/vendor/flag-icon-css/flags/4x3/ug.svg?be11ef3932f4010356d708d10c60f1e9";